import React from 'react';
import {ConfigFieldDefinitionBase} from './config-field-definition-base';
import {BooleanValueEditorComponent} from '../../../components/value-editors/boolean-value-editor/boolean-value-editor.component';

export class BooleanFieldDefinition extends ConfigFieldDefinitionBase {

    render(): React.ReactNode {
        return (<BooleanValueEditorComponent key={this.configurationKey}
                                             configurationKey={this.configurationKey}
                                             title={this.title}
                                             description={this.description} />);
    }
}